__turbopack_context__.v({
  "addToCart": "AddToCartButton-module__MWeMsW__addToCart",
  "addToCartButton": "AddToCartButton-module__MWeMsW__addToCartButton",
  "addToCartForm": "AddToCartButton-module__MWeMsW__addToCartForm",
  "addToCartStatus": "AddToCartButton-module__MWeMsW__addToCartStatus",
  "errorMessage": "AddToCartButton-module__MWeMsW__errorMessage",
});
